import { jsx as r, jsxs as s, Fragment as b } from "react/jsx-runtime";
import { useRef as B, useEffect as T } from "react";
import { useTranslation as _ } from "react-i18next";
import C from "react-slick";
import a from "@mui/material/Box";
import L from "@mui/material/Container";
import A from "@mui/material/Divider";
import l from "@mui/material/Grid";
import N from "@mui/material/IconButton";
import k from "@mui/material/List";
import F from "@mui/material/ListItem";
import m from "@mui/material/Typography";
import { makeStyles as j } from "tss-react/mui";
import { useLanguageContext as q } from "@lumirental/lumi-web-shared/lib/contexts/Language.context";
import { manageSmoothScrolling as D } from "../../../../../utils/index.js";
import G from "../../../../common/Button/Button.js";
import { CardBase as H } from "../../../../common/Cards/CardBase/CardBase.js";
import W from "../../../../common/Image/Image.js";
import E from "./BusCollection.style.js";
import M from "../../../../common/Icons/NavigateForward/NavigateForwardIcon.js";
import Q from "../../../../common/Icons/NavigateBack/NavigateBackIcon.js";
const R = j()(E), $ = ({ data: n }) => {
  const { classes: o } = R(), { t: i } = _(), g = B(), { language: d, isArabic: h } = q(), S = (n == null ? void 0 : n.heading) ?? "", v = (n == null ? void 0 : n.subHeading) ?? "", p = (n == null ? void 0 : n.list) ?? [], c = p.length > 1, w = {
    dots: c,
    infinite: c,
    arrows: c,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    rtl: h,
    autoplay: !1,
    autoplaySpeed: 2e3,
    nextArrow: c ? /* @__PURE__ */ r(N, { component: "span", children: /* @__PURE__ */ r(M, { language: d }) }) : /* @__PURE__ */ r(b, {}),
    prevArrow: c ? /* @__PURE__ */ r(N, { component: "span", children: /* @__PURE__ */ r(Q, { language: d }) }) : /* @__PURE__ */ r(b, {})
  }, f = [
    {
      id: 1,
      icon: "/images/png/features-icon/luggage.png",
      label: i("luggage_storage")
    },
    {
      id: 2,
      icon: "/images/png/features-icon/air-condition.png",
      label: i("air_condition")
    },
    {
      id: 1,
      icon: "/images/png/features-icon/rest-room.png",
      label: i("rest_room")
    },
    {
      id: 1,
      icon: "/images/png/features-icon/charging-plug.png",
      label: i("charging_docs")
    },
    {
      id: 1,
      icon: "/images/png/features-icon/microphone.png",
      label: i("microphone")
    }
  ];
  T(() => {
    const e = h ? p.length - 1 : 0, t = setTimeout(() => {
      var u;
      (u = g == null ? void 0 : g.current) == null || u.slickGoTo(e);
    }, 0);
    return () => clearTimeout(t);
  }, []);
  const y = () => {
    D("#reservationForm");
  };
  return /* @__PURE__ */ r(a, { py: { xs: 6, sm: 10, md: 15 }, className: o.wrapper, children: /* @__PURE__ */ s(L, { children: [
    /* @__PURE__ */ r(l, { container: !0, columnSpacing: 3, rowSpacing: 4, children: /* @__PURE__ */ s(l, { item: !0, xs: 12, sx: { textAlign: "center" }, mb: { xs: 3 }, children: [
      /* @__PURE__ */ r(m, { variant: "h1", mb: { xs: 1 }, className: o.heading, children: S }),
      /* @__PURE__ */ r(
        m,
        {
          variant: "h4",
          mb: { xs: 0, md: 2 },
          className: o.description,
          children: v
        }
      )
    ] }) }),
    /* @__PURE__ */ r(H, { className: o.card, children: /* @__PURE__ */ s(
      l,
      {
        container: !0,
        columnSpacing: 3,
        sx: { flexDirection: "row-reverse" },
        children: [
          /* @__PURE__ */ r(l, { item: !0, xs: 12, sm: 8, mb: { xs: 3, sm: 0 }, children: /* @__PURE__ */ r(a, { className: o.sliderWrapper, children: /* @__PURE__ */ r(C, { ...w, ref: g, children: p && p.map((e) => {
            var x;
            const t = (e == null ? void 0 : e.id) ?? 0, u = ((x = e == null ? void 0 : e.img) == null ? void 0 : x.url) ?? "";
            return /* @__PURE__ */ r(a, { className: o.carouselImg, children: /* @__PURE__ */ r("img", { src: u, alt: "Lumi Bus Img" }) }, t);
          }) }) }) }),
          /* @__PURE__ */ s(l, { item: !0, xs: 12, sm: 4, children: [
            /* @__PURE__ */ s(a, { mb: { xs: 2, sm: 3 }, children: [
              /* @__PURE__ */ r(m, { variant: "h2", className: o.title, children: i("49_seater_semi_luxury_coach") }),
              /* @__PURE__ */ r(
                A,
                {
                  classes: {
                    root: o.divider
                  }
                }
              ),
              /* @__PURE__ */ r(m, { variant: "h6", className: o.featureTitle, children: i("features") }),
              /* @__PURE__ */ r(k, { sx: { marginBottom: 2 }, className: o.featureList, children: f && f.map((e) => {
                const t = (e == null ? void 0 : e.id) ?? 0;
                return /* @__PURE__ */ s(F, { className: o.featureItem, children: [
                  /* @__PURE__ */ r(a, { mr: { xs: 2 }, children: /* @__PURE__ */ r(
                    W,
                    {
                      src: e == null ? void 0 : e.icon,
                      width: 24,
                      height: 24
                    }
                  ) }),
                  /* @__PURE__ */ r(
                    m,
                    {
                      variant: "body",
                      className: o.featureText,
                      children: e == null ? void 0 : e.label
                    }
                  )
                ] }, t);
              }) })
            ] }),
            /* @__PURE__ */ r(
              G,
              {
                fullWidth: !0,
                dataTestid: "getAQuoteId",
                className: o.quoteBtn,
                onClick: y,
                children: i("get_a_quote!")
              }
            )
          ] })
        ]
      }
    ) })
  ] }) });
}, mr = $;
export {
  mr as default
};
